import React from 'react';

import { InstantSearch, Configure } from 'react-instantsearch-dom';
import { CompanySearch } from '/components/company-search/components';

import algoliasearch from 'algoliasearch/lite';

const CompanySearchApp = () => {
    const {
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_SEARCH_API_KEY,
        ALGOLIA_INDEX,
    } = window.env;

    const searchClient = algoliasearch(
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_SEARCH_API_KEY,
    );

    return (
        <InstantSearch indexName={`${ALGOLIA_INDEX}-companies`} searchClient={searchClient}>
            <Configure hitsPerPage={999} />
            <CompanySearch />
        </InstantSearch>
    );
};

export { CompanySearchApp };
